<template>
<div class="expandable-area product-variants-panel" :class="{closed:status.variantsClosed}">
		<h3 class="expandable-title" @click="statusToggle('variantsClosed')">Variants
			<inline-svg class="arrow" :src="require('@/assets/img/chevron-top.svg')" />
		</h3>

		<div class="area-content">
			<div class="txt-wrap">
				<p>
					Add variants if this product has multiple options, such as size or color.
				</p>
			</div>
			<div class="variants-wrap">
				<div class="variant-box" v-for="(item, index) in variants" :key="index">
					<div class="left">
						<div class="label with-icon">
							Variant <info-icon info="eg. color, size..." />
						</div>
						<div class="form-group">
							<input-field small v-model="item.name"></input-field>
						</div>
						<div class="delete-icon" :class="{'locked':!is('editor')}" @click="deleteVariant(index)">
							<inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
						</div>
					</div>
					<div class="right">
						<div class="label-top-group">
							<div class="label with-icon">
								Options <info-icon info="eg. Blue, Green, M, L, XS...etc" />
							</div>
						</div>
						<p v-if="!item.options || !item.options.length" class="msg">No options yet, add an option to get
							started.</p>
						<div v-else class="option-items-wrap">
							<div class="option-item" v-for="(option, optindex) in item.options" :key="optindex">
								<input-field small v-model="option.name"></input-field>
								<div class="delete-icon" :class="{'locked':!is('editor')}"
								     @click="deleteOption(index, optindex)">
									<inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
								</div>
							</div>
						</div>
						<div class="layout-row">
							<v-button label="Add new option" :locked="!is('editor')" border @click="addNewOption(index)"/>
						</div>
					</div>
				</div>
				<div class="layout-row">
					<v-button border label="Add new variant" :locked="!is('editor')"
					          :disabled="variants && variants.length>=3" slim @click="addNewVariant" />
					<v-button style="margin-left:10px" border label="Manage variants..." slim
					          :loading="savingVariants" :locked="!is('editor')"
					          @click="openVariants()" :disabled="!variants || !variants.length" />
				</div>
			</div>
		</div>
</div>
</template>

<script>
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import ManageVariants from "@/views/funnels/funnel-plus/steps/products/manage-variants";
import {is} from "@/helpers/roles";
export default {
	name: "product-variants-panel",
	components: {ManageVariants, VButton, InputField, InfoIcon},
	props:['variants','funnelId','product','savingVariants'],
	data(){
		return {
			manageVariantsOpen: false,
			status: {
				variantsClosed: false,
			},
		}
	},
	methods:{
		is(role){
			return is(role)
		},
		openVariants() {
			this.$emit('openVariants')
		},
		statusToggle(key){
			this.status[key] = !this.status[key];
			localStorage.setItem('product.'+key, this.status[key]);
		},
		addNewVariant() {
			if (this.variants.length >= 3) {
				this.$warn(null, "You can only have a 3 variants maximum.");
				return;
			}
			this.variants.push({
				name: '',
				options: [{name: '', soldout: false}]
			})
		},
		deleteVariant(index) {
			this.variants.splice(index, 1);
		},
		addNewOption(index) {
			if (!this.variants[index].options)
				this.$set(this.variants[index], "options", []);
			this.variants[index].options.push({name: ''})
		},
		deleteOption(index, optindex) {
			this.variants[index].options.splice(optindex, 1)
		},
	},
	created() {
		this.status.variantsClosed = localStorage.getItem('product.variantsClosed')==="true";
	}
}
</script>

<style lang="scss" scoped>
.product-variants-panel {
	.delete-icon.locked {
		pointer-events: none;
		display: none;
	}
}
</style>
<style lang="scss">
.product-variants-panel {

}
</style>
